window.Products.Accessory.RuffleScrunchie = function() {};
window.Products.Accessory.RuffleScrunchie.inherits(window.Products.Accessory.Accessory);